export default "__VITE_ASSET__BA4lWJTd__"